import { Ident } from '@mode-switch/express';
export var RecordsQuery;
(function (RecordsQuery) {
    function make(query) {
        const id = Ident.next();
        return { id, ...query };
    }
    RecordsQuery.make = make;
})(RecordsQuery || (RecordsQuery = {}));
